import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-if.js";

import "../../../components/desktop/webinar/WebinarCardSearch/WebinarCardSearch";
import "../../../components/desktop/shared/SearchHeader";
import {
  checkPreviousButton,
  checkEmptyData,
  checkPaginationNext,
} from "../../../utils/SearchEventWebinar";

class SearchEventWebinar extends PolymerElement {
  static get template() {
    return html`
        <style>
          h1 {
            color: #000000;
            font-size: 24px;
            font-weight: 700;
            margin: 24px 0 16px 0;
          }

          .main-container {
            width: 660px;
          }

          .webinar-list-container {
            margin-top: 33px;
          }

          .btn-group{
            float: right;
            margin: 9px 0 60px 0;
          }

          .btn-group button {
            background-color: #3570D2;
            color: white;
            cursor: pointer;
            margin-left: 12px;
            border-radius: 5px;
            border: none;
            width: 160px;
            height: 44px;
          }
        
          .btn-group:after {
            content: "";
            clear: both;
            display: table;
          }
          .content-empty {
            text-align: center;
          }
          .content-empty h2 {
            font-size: 18px;
            font-weight: 700;
            color: #424242;
            margin: 0;
            margin-top: 60px;
          }
          .content-empty p {
            font-weight: 400;
            font-size: 16px;
            color: #7F7F7F;
            margin: 0
          }
        </style>
        <h1>Pencarian Webinar Terkait :</h1>
        <search-header keyword="[[keyword]]"></search-header>
        <template
          is="dom-if"
          if="[[checkEmptyData(webinarList, page, keyword)]]"
        >
          <div class="content-empty">
            <h2>Pencarian Tidak Ditemukan</h2>
            <p>Maaf, kata kunci yang Anda cari tidak ditemukan. Silakan ulangi pencarian dengan mengganti kata kunci dan pastikan penulisannya benar. </p>
          </div>
        </template>
        <div class="main-container">
          <div class="webinar-list-container">
              <dom-repeat items="{{webinarList}}" as="webinarItem">
                  <template>
                      <webinar-card-search webinar-item={{webinarItem}} is-login={{isLogin}}><webinar-card-search>
                  </template>
              <dom-repeat>
          </div>
          <div class="btn-group">
            <template
                is="dom-if"
                if="[[checkPreviousButton(page)]]"
            >
            <button on-click="onPreviousPage">< Sebelumnya</button>
            </template>
            <template
                is="dom-if"
                if="[[checkPaginationNext(webinarList)]]"
            >
                <button on-click="onNextPage">Selanjutnya ></button>
            </template>
          </div>
        </div>
    `;
  }

  static get properties() {
    return {
      isLogin: {
        type: Number,
      },
      webinarList: {
        type: Array,
        value: [],
      },
      keyword: {
        type: String,
      },
      page: {
        type: Number,
        value: 1
      },
      checkPreviousButton: {
        type: Function,
        value: () => checkPreviousButton,
      },
      checkEmptyData: {
        type: Function,
        value: () => checkEmptyData,
      },
      checkPaginationNext: {
        type: Function,
        value: () => checkPaginationNext,
      },
    };
  }

  onNextPage() {
    const newPage = this.page + 1;
    window.location.href = `/webinar/search?s=${this.keyword}&page=${newPage}`;
  }

  onPreviousPage() {
    const newPage = this.page - 1;
    window.location.href = `/webinar/search?s=${this.keyword}&page=${newPage}`;
  }

  ready() {
    super.ready();
  }
}
customElements.define("search-event-webinar", SearchEventWebinar);
